import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiTab: ThemeOptions["components"] = {
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: "32px",
      },
      indicator: {
        backgroundColor: "transparent",
      },
      scroller: ({ theme }) => ({
        minHeight: "32px",
        height: "32px",
        borderRadius: "8px",
        backgroundColor: theme.palette.primary.light,
      }),
    },
  },
  MuiTab: {
    defaultProps: {
      wrapped: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        ...typographyVariants.bodyMedium,
        padding: "0 15px",
        minHeight: "32px",
        color: theme.palette.info.main,
        textTransform: "none",
        borderRadius: "8px",
        "&.Mui-selected": {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
      }),
    },
  },
};
